import { useSearchParams } from "@shared/react-router-dom";

const useUnauthUrlFields = () => {
  const [searchParams] = useSearchParams();

  const payload = {
    utm_campaign: searchParams?.get("utm_campaign"),
    utm_medium: searchParams?.get("utm_medium"),
    utm_source: searchParams?.get("utm_source"),
  };

  Object.keys(payload).forEach(key => {
    if (payload[key] === null || payload[key] === undefined) {
      delete payload[key];
    }
  });

  return payload;
};

export { useUnauthUrlFields };
